// The maximum number of cloudv ariables that can be created in this scratch-gui instance.
export const MAXIMUM_CLOUD_VARIABLES = 250;

// The maximum number of cloud variables that can be created in a vanilla Scratch.
export const SCRATCH_MAX_CLOUD_VARIABLES = 10000;
